import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { orderBy, find } from 'lodash';
import moment from 'moment';

import { Trans } from 'react-i18next';

// ui
import { withStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemText from '@material-ui/core/ListItemText';
import Input from '@material-ui/core/Input';
import Select from '@material-ui/core/Select';
import Checkbox from '@material-ui/core/Checkbox';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';

import DamChart from './DamChartDaily';
import { regionRid } from '../../../../store/dam';

export const t = (text) => <Trans>{text}</Trans>;

const styles = (theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  button: {
    margin: theme.spacing(1),
  },
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const currentYear = moment().year();
const yearsRange = (start, end) => Array.from({
  length: (start - end),
}, (v, k) => (start - k).toString());
const years = yearsRange(currentYear, 2011);
// console.log(years(currentYear, currentYear-15));

class DamChartDailySumByRegion extends Component {
  constructor(props) {
    super(props);
    this.child = React.createRef();

    this.state = {
      selectedType: 'total_dam_storage',
      selectedYear: [`${currentYear}`, `${currentYear - 1}`, `${currentYear - 2}`],
      selectedRegion: '',
    };
  }

  static getDerivedStateFromProps(props, state) {
    // console.log(props.id + '-' + state.selectedDam);
    if (state.selectedRegion === '') {
      return {
        selectedRegion: parseInt(props.id, 10),
      };
      // console.log(props.id)
    }

    return null;
  }

  handleChange = (event) => {
    // console.log(event.target);
    if (event.target.name === 'selectedYear') {
      if (event.target.value.length <= 3) {
        this.setState({ [event.target.name]: event.target.value });
      }
    } else {
      this.setState({ [event.target.name]: event.target.value });
    }
  };

  handleChart = () => {
    this.child.current.renderChartSum();
  }

  render() {
    const {
      selectedType,
      selectedYear,
      selectedRegion,
    } = this.state;

    return (
      <div>
        <form autoComplete="off">
          <Grid container spacing={2}>
            <Grid item xs={6} sm={3} md={3} lg={3}>
              <FormControl>
                <InputLabel htmlFor="type">{t('ประเภทข้อมูล')}</InputLabel>
                <Select
                  value={selectedType}
                  onChange={this.handleChange}
                  inputProps={{
                    name: 'selectedType',
                    id: 'type',
                  }}
                >
                  <MenuItem value="total_dam_storage">{t('ปริมาณน้ำเก็บกัก')}</MenuItem>
                  <MenuItem value="total_dam_uses_water">{t('ปริมาณน้ำใช้การ')}</MenuItem>
                  <MenuItem value="total_dam_inflow">{t('ปริมาณน้ำไหลลง')}</MenuItem>
                  <MenuItem value="total_dam_released">{t('ปริมาณน้ำระบาย')}</MenuItem>
                  <MenuItem value="total_dam_inflow_acc">{t('ปริมาณน้ำไหลลงสะสม')}</MenuItem>
                  <MenuItem value="total_dam_released_acc">{t('ปริมาณน้ำระบายสะสม')}</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6} sm={3} md={3} lg={3}>
              <FormControl>
                <InputLabel htmlFor="year">ปี (สูงสุด 3 ปี)</InputLabel>
                <Select
                  multiple
                  value={selectedYear}
                  onChange={this.handleChange}
                  input={<Input id="year" />}
                  renderValue={(selected) => selected.join(', ')}
                  MenuProps={MenuProps}
                  inputProps={{
                    name: 'selectedYear',
                    id: 'year',
                  }}
                >
                  {years.map((year) => (
                    <MenuItem key={year} value={year}>
                      <Checkbox checked={selectedYear.indexOf(year) > -1} />
                      <ListItemText primary={year} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6} sm={4} md={4} lg={4}>
              <FormControl>
                <InputLabel htmlFor="year">{t('ภาค')}</InputLabel>
                <Select
                  value={selectedRegion}
                  onChange={this.handleChange}
                  inputProps={{
                    name: 'selectedRegion',
                    id: 'id',
                  }}
                >
                  <MenuItem key={99} value={0}>
                    {t('รวมทั้งประเทศ')}
                  </MenuItem>
                  {orderBy(regionRid, ['name'], ['asc']).map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                      {item.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6} sm={2} md={2} lg={2}>
              <FormControl>
                <Button variant="outlined" color="primary" size="small" onClick={this.handleChart}>
                  {t('แสดง')}
                </Button>
              </FormControl>
            </Grid>
          </Grid>
        </form>

        <DamChart
          ref={this.child}
          type={selectedType}
          id={selectedRegion}
          year={selectedYear}
          chartCalType="sum"
          name={selectedRegion ? find(regionRid, ['id', selectedRegion]).name : t('รวมทั้งประเทศ')}
        />
      </div>
    );
  }
}

DamChartDailySumByRegion.propTypes = {
  id: PropTypes.number.isRequired,
};

export default withStyles(styles)(DamChartDailySumByRegion);
